import { CursorArrowRaysIcon, DocumentMagnifyingGlassIcon, SparklesIcon } from "@heroicons/react/24/outline";

const STEPS = [
  {
    title: "Discover pages",
    detail: "We map important pages on your domain.",
    Icon: DocumentMagnifyingGlassIcon,
  },
  {
    title: "Browse like a visitor",
    detail: "We navigate and interact the way a real user would.",
    Icon: CursorArrowRaysIcon,
  },
  {
    title: "Surface UX issues",
    detail: "We flag usability problems and what to prioritize.",
    Icon: SparklesIcon,
  },
] as const;

export function DomainAddHeader() {
  return (
    <div className="mb-6">
      <h1 className="mb-2 text-2xl font-semibold tracking-tight text-gray-900">Add a website</h1>
      <p className="max-w-xl text-[0.95rem] leading-relaxed text-gray-600">
        Enter a website. We’ll find key pages, browse them like a real visitor, and surface UX issues to fix.
      </p>
    </div>
  );
}

export default function DomainAddIntro() {
  return (
    <ol className="space-y-3.5">
      {STEPS.map((step, index) => (
        <li key={step.title} className="flex gap-3">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <step.Icon className="h-5 w-5" aria-hidden="true" />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-gray-900">
              <span className="mr-1.5 text-primary">{index + 1}.</span>
              {step.title}
            </p>
            <p className="mt-0.5 text-sm text-gray-600">{step.detail}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
